import React from "react";
import {
  SEO,
  PageLayout,
  Section,
  BackgroundImages,
  FishermanHeader,
  MarkdownContent,
  ContactForm,
  createDefaultMessageFromState,
  Content,
  Email,
  Phone,
  FadeReveal,
  Location,
  HoursOfOperation,
  Map,
} from "@bluefin/components";
import { Grid } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";

export default class ContactPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          title={fishermanBusinessWebsitePage.seoTitle}
          ogUrl={"https://www.pacificartistry.com/contact/"}
        />
        <PageLayout className={"contact-page"} hero={null}>
          <Section className={"default-hero-section"}>
            <BackgroundImages
              images={getComponentFiles({
                components: fishermanBusinessWebsitePage.components,
                componentName: "HeroElement",
              })}
              carouselProps={{
                leftArrowIcon: "arrow-left",
                rightArrowIcon: "arrow-right",
              }}
              imageProps={{ loadStrategy: "eager" }}
            >
              <div className={"content-container"}>
                <FishermanHeader
                  as={"h1"}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "contact_hero_header",
                    defaultValue: "Contact",
                  })}
                />
                <FishermanHeader
                  as={"h2"}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "contact_hero_subheader",
                    defaultValue: "Enhancing The Beauty",
                  })}
                />
                <MarkdownContent
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "contact_hero_description",
                  })}
                />
              </div>
            </BackgroundImages>
          </Section>
          <Section className={"contact-form-section"}>
            <ContactForm
              constructMessage={createDefaultMessageFromState}
              fields={[
                {
                  label: "name",
                  displayLabel: "💅Brides Name:",
                  placeholder: "Your name here",
                  type: "input",
                  required: true,
                },
                {
                  label: "Event Date",
                  displayLabel: "📆Wedding Date",
                  placeholder: "MM/DD/YYYY",
                  type: "input",
                  required: true,
                },
                {
                  label: "☎️Phone number ",
                  placeholder: "Phone Number",
                  type: "input",
                  required: true,
                },
                {
                  label: "email",
                  displayLabel: "📧Bride’s email",
                  placeholder: "Email",
                  type: "input",
                  inputType: "email",
                  required: true,
                },
                {
                  label: "Event Location",
                  displayLabel: "⏰Getting Ready Location",
                  placeholder: "(Venue, hotel, Airbnb, etc...)",
                  type: "input",
                  required: true,
                },
                {
                  label: "timeHairMakeUpNeedToBeFinished",
                  displayLabel:
                    "💒What time does hair and Make Up need to be finished",
                  placeholder:
                    "This helps us build the perfect beauty timeline!",
                  type: "input",
                  required: true,
                },
                {
                  label: "services",
                  displayLabel:
                    "👰Who is getting glammed up?Let us know how many people will need hair, makeup, or both",
                  type: "multiSelect",
                  required: true,
                  options: [
                    { label: "Bride Hair", value: "Bride Hair" },
                    { label: "Bride Makeup", value: "Bride Makeup" },
                    { label: "Bride Trial", value: "Bride Trial" },
                    { label: "Bridesmaids Hair", value: "Bridesmaids Hair" },
                    {
                      label: "Bridesmaid’s MakeUp",
                      value: "Bridesmaid’s MakeUp",
                    },
                    {
                      label: "Other attendees Hair",
                      value: "Other attendees Hair",
                    },
                    {
                      label: "Other attendees Makeup",
                      value: "Other attendees Makeup",
                    },
                  ],
                },
                {
                  label: "grazingBoardsOrMimosaBar",
                  displayLabel: "Morning grazing boards or mimosa bar?",
                  type: "multiSelect",
                  required: false,
                  options: [
                    {
                      label: "Morning Grazing Boards",
                      value: "Morning Grazing Boards",
                    },
                    { label: "mimosa Bar", value: "mimosa Bar" },
                  ],
                },
                {
                  label: "flowerGirls",
                  displayLabel: "Flower girls",
                  type: "multiSelect",
                  required: false,
                  options: [
                    { label: "Hair Extensions", value: "Hair Extensions" },
                    { label: "Lash Extensions", value: "Lash Extensions" },
                  ],
                },
                {
                  label: "numberOfServices",
                  displayLabel: "Total number of services",
                  placeholder: "Total number of services",
                  type: "input",
                  required: false,
                },
                {
                  label: "specialRequests",
                  displayLabel: "❕Any special requests or must-know details?",
                  placeholder:
                    "(Sensitive skin, specific styles, early start time, touch-ups needed, morning catering, mimosa bar,etc.)",
                  type: "textArea",
                  required: false,
                },
                {
                  label: "pinterestBordOrInspoPicsLink",
                  displayLabel:
                    "📌Do you have a Pinterest board or inspo pics?",
                  placeholder: "Drop a link here!",
                  type: "input",
                  required: false,
                },
              ]}
              buttonText={"Send Message"}
              centeredHeaders={false}
              hideOptIn={false}
              className={""}
              fluidButton={false}
              header={
                <div className={"contact-form-header"}>
                  <Content columns={1}>
                    <Content.Markup
                      isMarkdown={false}
                      textAlign={"center"}
                      as={"h3"}
                      className={"ui header"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "contact_form_header",
                      })}
                    />
                    <Content.Markup
                      isMarkdown={true}
                      textAlign={"center"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "contact_form_description",
                      })}
                    />
                  </Content>
                </div>
              }
              inline={false}
              showLabels={true}
              subheader={""}
              termsCopy={""}
              withContainer={false}
              locationId={fishermanBusiness.primaryLocation._id}
              businessId={fishermanBusiness._id}
              businessType={fishermanBusiness.type}
              event={{ category: "Contact", action: "Submit Inquiry" }}
            />
            <div className={"contact-information"}>
              <p
                children={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "contact_form_description_alternate_contact",
                  defaultValue:
                    "If you prefer to get in touch with us directly:",
                })}
              />
              <Email email={fishermanBusiness.primaryLocation.email} />
              <Phone phone={fishermanBusiness.primaryLocation.phoneNumber} />
            </div>
          </Section>
          <Section className={"contact-info-section"}>
            <Grid stackable={true} className={"contact-info-container"}>
              <Grid.Column width={8} className={"info-column"}>
                <FadeReveal duration={1250} triggerOnce={true} delay={0}>
                  <Location
                    phone={fishermanBusiness.primaryLocation.phoneNumber}
                    email={fishermanBusiness.primaryLocation.email}
                    address={{
                      street: fishermanBusiness.primaryLocation.street,
                      city: fishermanBusiness.primaryLocation.city,
                      state: fishermanBusiness.primaryLocation.state,
                      zip: fishermanBusiness.primaryLocation.zipCode,
                    }}
                    businessName={fishermanBusiness.name}
                    showBusinessName={false}
                  />
                  <p children={"Opening Hours:"} />
                  <HoursOfOperation
                    hours={fishermanBusiness.primaryLocation.hours}
                    displayOption={"grouped"}
                    inlineHours={true}
                    truncateLabels={true}
                  />
                </FadeReveal>
              </Grid.Column>
              <Grid.Column width={8} className={"map-column"}>
                <FadeReveal duration={1250} triggerOnce={true} delay={450}>
                  <Map
                    businessName={fishermanBusiness.name}
                    address={{
                      street: fishermanBusiness.primaryLocation.street,
                      city: fishermanBusiness.primaryLocation.city,
                      state: fishermanBusiness.primaryLocation.state,
                      zip: fishermanBusiness.primaryLocation.zipCode,
                    }}
                  />
                </FadeReveal>
              </Grid.Column>
            </Grid>
          </Section>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        _id
        email
        phoneNumber
        street
        city
        state
        zipCode
        hours {
          day
          open
          close
        }
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Contact" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        contentNodes {
          content
        }
      }
      seoTitle
    }
  }
`;
